import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { Group } from '../../master-consulta-grupos-models';
import { MasterConsultaGruposService } from '../../master-consulta-grupos.service';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';

@Component({
  selector: 'app-master-mensagem-duplicar',
  templateUrl: './master-mensagem-duplicar.component.html',
  styleUrls: ['./master-mensagem-duplicar.component.scss'],
})
export class MasterMensagemDuplicarComponent implements OnInit {

  group: Group;
  constructor(public dialogRef: MatDialogRef<MasterMensagemDuplicarComponent>,
    private masterConstultaGroupService: MasterConsultaGruposService,
    private msalService: MsalService,
    private shared:SharedVariable
  ) {

  }

  ngOnInit() { }

  duplicateGroup() {
    this.group.name = this.group.name + ' - Cópia';
    this.masterConstultaGroupService.duplicateGroup(this.group)
      .subscribe(data => {
        this.dialogRef.close(true);
        this.groupDeletionLog();
      });
  }


  groupDeletionLog() {
    const userName = this.shared.mailUser;

    const log = {
      userName: userName,
      data: new Date(),
    }
    this.masterConstultaGroupService.groupDeletionLog(log);
  }


}
